import { useSelector } from "react-redux";
import AssetShareDatatable from "../../../../../Components/Shared/assets-share-datatable";
import { GetObject } from "../../../../../Redux/Reducers/redux-slice-asset";

function AdminTitleSingleShares() {
  const title = useSelector(GetObject);

  return <AssetShareDatatable asset={title} />;
}

export default AdminTitleSingleShares;
